import { render, staticRenderFns } from "./proContract.vue?vue&type=template&id=f36fc9e4&scoped=true&"
import script from "./proContract.vue?vue&type=script&lang=js&"
export * from "./proContract.vue?vue&type=script&lang=js&"
import style0 from "./proContract.vue?vue&type=style&index=0&id=f36fc9e4&scoped=true&lang=css&"
import style1 from "./proContract.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f36fc9e4",
  null
  
)

export default component.exports